import React from 'react';
import { FilterIcon } from '@revfluence/fresh-icons/solid';
import { DismissableBadge } from '@/applications/Social/components/filters/badges/dismissable-badge';
import { Badge } from './hooks/use-search-badges';
import CreatorDemographicsInterestsBadge from './creator-demographics-interests';
import CreatorDemographicsMinFollowersBadge from './creator-demographics-min-followers';
import CreatorDemographicsMaxFollowersBadge from './creator-demographics-max-followers';
import CreatorDemographicsMinEngagementsBadge from './creator-demographics-min-engagements';
import CreatorDemographicsMaxEngagementsBadge from './creator-demographics-max-engagements';
import DemographicsAgeBadge from './demographics-age';
import DemographicsCountriesBadge from './demographics-countries';
import DemographicsGenderBadge from './demographics-gender';

interface CreatorSearchBadgesProps {
  badges: Record<string, Badge>;
  onClick: () => void;
  onDismiss: (id: string) => (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CreatorSearchBadges = ({ badges, onClick, onDismiss }: CreatorSearchBadgesProps) => {
  const {
    ageBuckets,
    countries,
    genders,
    interests,
    minFollowers,
    maxFollowers,
    minEngagements,
    maxEngagements,
    majorAudienceAgeBuckets,
    majorAudienceCountries,
    majorAudienceGenders
  } = badges;

  return (
    <div className="flex justify-start flex-wrap">
      { ageBuckets && <DemographicsAgeBadge data={ageBuckets} onClick={onClick} onDismiss={onDismiss(ageBuckets.id)} />}
      { genders && <DemographicsGenderBadge data={genders} onClick={onClick} onDismiss={onDismiss(genders.id)} />}
      { countries && <DemographicsCountriesBadge data={countries} onClick={onClick} onDismiss={onDismiss(countries.id)} />}
      { minFollowers && <CreatorDemographicsMinFollowersBadge data={minFollowers} onClick={onClick} onDismiss={onDismiss(minFollowers.id)} />}
      { maxFollowers && <CreatorDemographicsMaxFollowersBadge data={maxFollowers} onClick={onClick} onDismiss={onDismiss(maxFollowers.id)} />}
      { minEngagements && <CreatorDemographicsMinEngagementsBadge data={minEngagements} onClick={onClick} onDismiss={onDismiss(minEngagements.id)} />}
      { maxEngagements && <CreatorDemographicsMaxEngagementsBadge data={maxEngagements} onClick={onClick} onDismiss={onDismiss(maxEngagements.id)} />}
      { interests && <CreatorDemographicsInterestsBadge data={interests} onClick={onClick} onDismiss={onDismiss(interests.id)} />}
      { majorAudienceAgeBuckets && <DemographicsAgeBadge data={majorAudienceAgeBuckets} onClick={onClick} onDismiss={onDismiss(majorAudienceAgeBuckets.id)} />}
      { majorAudienceGenders && <DemographicsGenderBadge data={majorAudienceGenders} onClick={onClick} onDismiss={onDismiss(majorAudienceGenders.id)} />}
      { majorAudienceCountries && <DemographicsCountriesBadge data={majorAudienceCountries} onClick={onClick} onDismiss={onDismiss(majorAudienceCountries.id)} />}
      <DismissableBadge
        variant="secondary"
        className="mr-2 mb-2"
        aria-label="Filters"
        role="button"
        data-dd-action-name="open-analytics-filters"
        onClick={onClick}
      >
        <FilterIcon className="mr-2" />Filters
      </DismissableBadge>
    </div>
  );
};

export default CreatorSearchBadges;
